import React from 'react'


const OfferCard = ({ img, text }) => {

    return (

        <div className=" col-lg-4 col-md-6 mx-auto col-xs-12 col-sm-12 card_hover py-0" >
            <div className="service">
                <div className="content">
                    <div className="serviceBx">
                        <img className="img-fluid" src={img} alt="Card image cap" />
                        <h4 className="offer_p">{text}</h4>
                        <p>Coming Soon... </p>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default OfferCard
